import { Box } from '@material-ui/core';
import { SAccordion } from '@setvi/shared/components';

interface SalesFAQProps {
  accordions: {
    name: string;
    content: string;
  }[];
  expanded: string;
  setExpanded: (expanded: string) => void;
}

export const Accordions = ({
  accordions,
  expanded,
  setExpanded
}: SalesFAQProps) => (
  <Box width="100%">
    {accordions?.map(({ name, content }) => (
      <SAccordion
        title={name}
        // eslint-disable-next-line react/no-danger
        content={<div dangerouslySetInnerHTML={{ __html: content }} />}
        onClick={() => setExpanded(expanded === name ? null : name)}
        expanded={expanded === name}
        key={name}
      />
    ))}
  </Box>
);
